import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Reframe } from './components/Reframe';
import { ProductIntro } from './components/ProductIntro';
import { Protocol } from './components/Protocol';
import { WhyOldFails } from './components/WhyOldFails';
import { Results } from './components/Results';
import { Includes } from './components/Includes';
import { NotForYou } from './components/NotForYou';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { SalesNotifications } from './components/SalesNotifications';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    ;
    (window as any).fbq('init', '1703383767307378');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream overflow-x-hidden selection:bg-terracotta/20" data-id="element-0">
      <main className="relative" data-id="element-1">
        {/* Subtle background texture/gradient */}
        <div className="fixed inset-0 pointer-events-none opacity-40 z-0" data-id="element-2">
          <div className="absolute top-0 left-0 w-full h-96 bg-gradient-to-b from-white to-transparent" data-id="element-3" />
          <div className="absolute bottom-0 left-0 w-full h-96 bg-gradient-to-t from-sage-light to-transparent" data-id="element-4" />
        </div>

        <div className="relative z-10" data-id="element-5">
          <Hero data-id="element-6" />

          <div className="w-full max-w-xs mx-auto h-px bg-gradient-to-r from-transparent via-sage/20 to-transparent my-4" data-id="element-7" />

          <PainPoints data-id="element-8" />
          <Reframe data-id="element-9" />
          <ProductIntro data-id="element-10" />

          <div className="w-full max-w-xs mx-auto h-px bg-gradient-to-r from-transparent via-sage/20 to-transparent my-8" data-id="element-11" />

          <Protocol data-id="element-12" />
          <WhyOldFails data-id="element-13" />
          <Results data-id="element-14" />
          <Includes data-id="element-15" />

          <div className="w-full max-w-xs mx-auto h-px bg-gradient-to-r from-transparent via-sage/20 to-transparent my-8" data-id="element-16" />

          <NotForYou data-id="element-17" />
          <Guarantee data-id="element-18" />
          <FinalCTA data-id="element-19" />
        </div>
      </main>

      <footer className="py-8 text-center text-sage/60 text-sm relative z-10" data-id="element-20">
        <p data-id="element-21">© 2026 Calma Espiritual</p>
      </footer>

      <SalesNotifications data-id="element-22" />
    </div>;
}